import React from 'react';

const Highlights = ({ className }) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#B1B1B1" fillOpacity="0.22" />
            <path className='ac-s' d="M22.5489 16.927C22.8483 16.0057 24.1517 16.0057 24.4511 16.9271L25.4084 19.8734C25.5422 20.2854 25.9262 20.5643 26.3594 20.5643H29.4574C30.4261 20.5643 30.8289 21.804 30.0451 22.3734L27.5389 24.1943C27.1884 24.4489 27.0417 24.9003 27.1756 25.3123L28.1329 28.2586C28.4323 29.1799 27.3778 29.946 26.5941 29.3766L24.0878 27.5557C23.7373 27.3011 23.2627 27.3011 22.9122 27.5557L20.4059 29.3766C19.6222 29.946 18.5677 29.1799 18.8671 28.2586L19.8244 25.3123C19.9583 24.9003 19.8116 24.4489 19.4611 24.1943L16.9549 22.3734C16.1711 21.804 16.5739 20.5643 17.5426 20.5643H20.6406C21.0738 20.5643 21.4578 20.2854 21.5916 19.8734L22.5489 16.927Z" stroke="white" />
        </svg>
    )
}

export default Highlights;